import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

function IndividualProfileSkeleton() {
  return (
    <div className="parentContainer">
      <div className="mainContainer">
        {/* TitleBar Skeleton */}
        <div style={{ marginBottom: "24px" }}>
          <Skeleton height={40} width={250} style={{ marginBottom: "8px" }} />
          <Skeleton height={20} width={180} />
        </div>

        {/* Profile Header */}
        <div style={{ marginBottom: "32px", display: "flex", gap: "24px", alignItems: "center" }}>
          <Skeleton circle height={100} width={100} />
          <div style={{ flex: 1 }}>
            <Skeleton height={32} width={200} style={{ marginBottom: "8px" }} />
            <Skeleton height={20} width={150} />
          </div>
        </div>

        {/* Stats Cards */}
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))", gap: "16px", marginBottom: "32px" }}>
          {[1, 2, 3, 4].map((i) => (
            <div key={i}>
              <Skeleton height={100} />
            </div>
          ))}
        </div>

        {/* Graph/Chart Area */}
        <div style={{ marginBottom: "24px" }}>
          <Skeleton height={300} />
        </div>

        {/* Data Table */}
        <div>
          <Skeleton height={24} width={150} style={{ marginBottom: "16px" }} />
          {[1, 2, 3, 4, 5].map((i) => (
            <Skeleton key={i} height={60} style={{ marginBottom: "8px" }} />
          ))}
        </div>
      </div>
    </div>
  );
}

export default IndividualProfileSkeleton;
